import { type AbstractControl, type ValidationErrors } from '@angular/forms';

import { type QuestionValidator } from './interfaces';

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export function emailValidator(): QuestionValidator {
  return (_: AbstractControl, value: string): ValidationErrors | null => {
    return !value || EMAIL_REGEXP.test(value)
      ? null
      : {
          '_system.errorEmailInvalid': {
            valid: false,
          },
        };
  };
}
